import { render, staticRenderFns } from "./PreviewForm22.vue?vue&type=template&id=6d63b18c&scoped=true"
import script from "./PreviewForm22.vue?vue&type=script&lang=ts"
export * from "./PreviewForm22.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d63b18c",
  null
  
)

export default component.exports